exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bookForm.el-form--label-top .el-form-item__label {\n    margin: 0;\n    padding: 0\n}\n.bookForm .el-form-item {\n    margin-bottom: 0;\n}\n.bookForm .el-checkbox {\n    margin-left: 30px;\n    margin-bottom:0;\n}\n.el-dialog__body {\n    padding: 10px 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib?{"esModule":true,"extractCSS":false}!./ClientApp/calendar/book.vue?vue&type=style&index=0&lang=css&
// module id = 336
// module chunks = 2